import { render, staticRenderFns } from "./footerUp.vue?vue&type=template&id=2761ec8d&scoped=true&"
import script from "./footerUp.vue?vue&type=script&lang=js&"
export * from "./footerUp.vue?vue&type=script&lang=js&"
import style0 from "./footerUp.vue?vue&type=style&index=0&id=2761ec8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2761ec8d",
  null
  
)

export default component.exports